export const ExperienceHighlights = ({ highlights }: { highlights: string[] }) => (
  <ul className="space-y-2">
    {highlights.map((item, idx) => (
      <li key={idx} className="flex items-start gap-2 text-muted-foreground">
        <span className="text-primary mt-1">•</span>
        <span className="leading-relaxed">{item}</span>
      </li>
    ))}
  </ul>
);
